<template>
  <form class="checkout-step-2" @submit.prevent="submit">
    <div class="row">
      <div class="col-lg-6">
        <form-group
          id="card"
          type="tel"
          v-model="form.card"
          :errors="errors.card"
          placeholder="**** **** **** ****"
          label="Número do cartão*"
        />
        <form-group
          id="name"
          v-model="form.name"
          :errors="errors.name"
          placeholder="Digite o nome do titular"
          label="Titular do cartão*"
        />
        <div class="form-row">
          <div class="col-lg-8">
            <form-group
              id="expire"
              type="tel"
              v-model="form.expire"
              :errors="errors.expire"
              placeholder="MM/AAAA"
              label="Validade*"
            />
          </div>
          <div class="col-lg-4">
            <form-group
              id="cvv"
              type="tel"
              v-model="form.cvv"
              :errors="errors.cvv"
              placeholder="CVV"
              label="Código*"
            />
          </div>
        </div>
        <form-group
          id="cpf"
          type="tel"
          v-model="form.cpf"
          :errors="errors.cpf"
          placeholder="Digite o CPF do titular"
          label="CPF do titular*"
        />
        <form-group
          id="cpf"
          type="tel"
          v-model="form.cpf"
          :errors="errors.cpf"
          placeholder="Digite o CPF do titular"
          label="CPF do titular*"
        />
        <form-group
          id="birthday"
          type="tel"
          v-model="form.birthday"
          :errors="errors.birthday"
          placeholder="DD/MM/AAAA"
          label="Data de nascimento do titular*"
        />
        <form-group
          id="phone"
          type="tel"
          v-model="form.phone"
          :errors="errors.phone"
          placeholder="Digite o número de telefone do titular"
          label="Telefone do titular*"
        />
      </div>
      <div class="col-lg-6">
        <credit-card :data="form" class="ml-auto" />
      </div>
    </div>
    <div class="text-right">
      <button class="btn btn-success px-5 font-weight-bold">
        Finalizar compra
      </button>
    </div>
  </form>
</template>

<script>
import CreditCard from "./CreditCard";
import { formFields } from "@/functions/helpers.js";

export default {
  components: { CreditCard },
  data() {
    return {
      loading: false,
      ...formFields([
        "card",
        "name",
        "expire",
        "cvv",
        "cpf",
        "cpf",
        "birthday",
        "phone"
      ])
    };
  },
  methods: {
    submit() {
      this.$emit("success", this.form);
    }
  }
};
</script>
